"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const appConstants_1 = require("../constants/appConstants");
const HttpRepository = {
    tradeshiftGoFrontend: () => axios_1.default.create({
        baseURL: '',
        timeout: appConstants_1.httpConstants.timeout,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
            'X-Tradeshift-RequestId': crypto.randomUUID(),
        },
    }),
    tradeshiftGo: () => axios_1.default.create({
        baseURL: `${globalThis.config.TRADESHIFT_GO_HOST}/external`,
        timeout: appConstants_1.httpConstants.timeout,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
            'X-Tradeshift-RequestId': crypto.randomUUID(),
        },
    }),
    tradeshiftGoMulti: () => axios_1.default.create({
        baseURL: `${globalThis.config.TRADESHIFT_GO_HOST}/external`,
        timeout: appConstants_1.httpConstants.timeout,
        withCredentials: true,
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-Tradeshift-RequestId': crypto.randomUUID(),
        },
    }),
    tradeshiftBlobRequest: () => axios_1.default.create({
        baseURL: `${globalThis.config.TRADESHIFT_GO_HOST}/external`,
        timeout: appConstants_1.httpConstants.timeout,
        withCredentials: true,
        responseType: 'blob',
        headers: {
            'X-Tradeshift-RequestId': crypto.randomUUID(),
            'Cache-Control': 'no-cache',
        },
    }),
    payments: (token) => axios_1.default.create({
        baseURL: globalThis.config.PAYMENTS_EXTERNAL_HOST,
        timeout: appConstants_1.httpConstants.timeout,
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
            'X-Tradeshift-RequestId': crypto.randomUUID(),
        },
    }),
    fintechCards: (token) => axios_1.default.create({
        baseURL: globalThis.config.FINTECH_PAYMENTS_HOST,
        timeout: appConstants_1.httpConstants.timeout,
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
            'X-Tradeshift-RequestId': crypto.randomUUID(),
        },
    }),
};
exports.default = HttpRepository;
